<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="structureType">Mix ID</label>
                    <input
                        type="text"
                        class="form-control"
                        id="structureType"
                        [(ngModel)]="target.structureType"
                        name="structureType"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="partOfTheStructure">Intended Use</label>
                    <input
                        type="text"
                        class="form-control"
                        id="partOfTheStructure"
                        [(ngModel)]="target.partOfTheStructure"
                        name="partOfTheStructure"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="designPsi">Design PSI</label>
                    <input
                        type="text"
                        class="form-control"
                        id="designPsi"
                        [(ngModel)]="target.designPsi"
                        name="designPsi"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="supplier">Supplier</label>
                    <wj-combo-box
                        id="supplier"
                        [(ngModel)]="target.supplier"
                        name="supplier"
                        [itemsSource]="concreteVendorOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isEditable]="false"
                        style="width: 100%"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="addMixturesRequired">Add Mixtures Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="addMixturesRequired"
                        [(ngModel)]="target.addMixturesRequired"
                        name="addMixturesRequired"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="maxWaterRatio">Max Water Ratio</label>
                    <input
                        type="text"
                        class="form-control"
                        id="maxWaterRatio"
                        [(ngModel)]="target.maxWaterRatio"
                        name="maxWaterRatio"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="slumpRequirement">Slump Requirement</label>
                    <input
                        type="text"
                        class="form-control"
                        id="slumpRequirement"
                        [(ngModel)]="target.slumpRequirement"
                        name="slumpRequirement"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="cylindersNeeded">Cylinders Needed</label>
                    <input
                        type="text"
                        class="form-control"
                        id="cylindersNeeded"
                        [(ngModel)]="target.cylindersNeeded"
                        name="cylindersNeeded"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="airRequirement">Air Requirement</label>
                    <input
                        type="text"
                        class="form-control"
                        id="airRequirement"
                        [(ngModel)]="target.airRequirement"
                        name="airRequirement"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="twentyEightDayStrength">28 Day Strength</label>
                    <input
                        type="text"
                        class="form-control"
                        id="twentyEightDayStrength"
                        [(ngModel)]="target.twentyEightDayStrength"
                        name="twentyEightDayStrength"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="curingReqNumberOfTestRequired">Frequency of Samples</label>
                    <input
                        type="text"
                        class="form-control"
                        id="curingReqNumberOfTestRequired"
                        [(ngModel)]="target.curingReqNumberOfTestRequired"
                        name="curingReqNumberOfTestRequired"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="maxLifts">Max Lift Height</label>
                    <input
                        type="text"
                        class="form-control"
                        id="maxLifts"
                        [(ngModel)]="target.maxLifts"
                        name="maxLifts"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="maxTimeOnLifts">Max Time on Lifts</label>
                    <input
                        type="text"
                        class="form-control"
                        id="maxTimeOnLifts"
                        [(ngModel)]="target.maxTimeOnLifts"
                        name="maxTimeOnLifts"
                    />
                </div>
            </div>
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="timeToPourAllowed">Time to Pour Allowed</label>
                    <input
                        type="text"
                        class="form-control"
                        id="timeToPourAllowed"
                        [(ngModel)]="target.timeToPourAllowed"
                        name="timeToPourAllowed"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 mb-3">
                <div class="form-group">
                    <label for="minTemperatureRequired">Min Air Temp Required</label>
                    <input
                        type="text"
                        class="form-control"
                        id="minTemperatureRequired"
                        [(ngModel)]="target.minTemperatureRequired"
                        name="minTemperatureRequired"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()">Save</button>
    </div>
</form>
